/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    owner
    email
    phone
    first_name
    last_name
    photo_url
    cover_url
    notes
    active
    createdAt
    watchlist {
      watchlistVideoId
      createdAt
    }
    currentVideo {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    history {
      historyVideoId
      createdAt
    }
    favorites {
      favoriteVideoId
      createdAt
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    userDesignerId
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    orders {
      items {
        id
        owner
        customer {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        orderCustomerId
        total
        order
        createdAt
      }
      nextToken
    }
    cart {
      id
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      owner
      items
    }
  }
}
`;
export const listUsers = `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    nextToken
  }
}
`;
export const getCart = `query GetCart($id: ID!) {
  getCart(id: $id) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    owner
    items
  }
}
`;
export const listCarts = `query ListCarts(
  $filter: ModelCartFilterInput
  $limit: Int
  $nextToken: String
) {
  listCarts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      owner
      items
    }
    nextToken
  }
}
`;
export const getSub = `query GetSub($subDesignerId: String!, $createdAt: AWSDateTime!) {
  getSub(subDesignerId: $subDesignerId, createdAt: $createdAt) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    subDesignerId
    stripeId
    stripeSubId
    createdAt
    owner
  }
}
`;
export const listSubs = `query ListSubs(
  $subDesignerId: String
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelSubFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSubs(
    subDesignerId: $subDesignerId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      subDesignerId
      stripeId
      stripeSubId
      createdAt
      owner
    }
    nextToken
  }
}
`;
export const getCategory = `query GetCategory($id: ID!) {
  getCategory(id: $id) {
    id
    owner
    name
    description
    createdAt
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const listCategorys = `query ListCategorys(
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getShow = `query GetShow($id: ID!) {
  getShow(id: $id) {
    id
    owner
    title
    description
    release_date
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const listShows = `query ListShows(
  $filter: ModelShowFilterInput
  $limit: Int
  $nextToken: String
) {
  listShows(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getVideo = `query GetVideo($id: ID!) {
  getVideo(id: $id) {
    id
    owner
    title
    description
    status
    url
    thumbnail
    createdAt
    views {
      user
      video
      createdAt
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    products {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    designers {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    season
    episode
    release_date
    duration
    likes
    src_video
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const listVideos = `query ListVideos(
  $filter: ModelVideoFilterInput
  $limit: Int
  $nextToken: String
) {
  listVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getTag = `query GetTag($id: ID!) {
  getTag(id: $id) {
    id
    tag
    type
    videos {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    designers {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    owner
  }
}
`;
export const listTags = `query ListTags($filter: ModelTagFilterInput, $limit: Int, $nextToken: String) {
  listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tag
      type
      videos {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      designers {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      owner
    }
    nextToken
  }
}
`;
export const getPendingVideo = `query GetPendingVideo($id: ID!) {
  getPendingVideo(id: $id) {
    id
    owner
    title
    description
    status
    createdAt
    src_video
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoCategoryId
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoShowId
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    pendingVideoDesignerId
    season
    episode
    duration
  }
}
`;
export const listPendingVideos = `query ListPendingVideos(
  $filter: ModelPendingVideoFilterInput
  $limit: Int
  $nextToken: String
) {
  listPendingVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      title
      description
      status
      createdAt
      src_video
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      pendingVideoCategoryId
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      pendingVideoShowId
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      pendingVideoDesignerId
      season
      episode
      duration
    }
    nextToken
  }
}
`;
export const getProductVideo = `query GetProductVideo($id: ID!) {
  getProductVideo(id: $id) {
    id
    owner
    product {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    timestamp
  }
}
`;
export const listProductVideos = `query ListProductVideos(
  $filter: ModelProductVideoFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      product {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      video {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      timestamp
    }
    nextToken
  }
}
`;
export const getProduct = `query GetProduct($id: ID!) {
  getProduct(id: $id) {
    id
    upc
    owner
    name
    description
    caption
    collection
    attributes
    price
    image
    supplier {
      id
      name
      description
      address
      phone
      contact
      url
      api
      schema
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      owner
    }
    product_id
    meta
    active
    createdAt
    box_size
    designer
    videos {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    relatedItems {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    relatedTo {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    productCategoryId
    mainProductCategoryId
    category {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
  }
}
`;
export const listProducts = `query ListProducts(
  $filter: ModelProductFilterInput
  $limit: Int
  $nextToken: String
) {
  listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    nextToken
  }
}
`;
export const getProductCategory = `query GetProductCategory($id: ID!) {
  getProductCategory(id: $id) {
    id
    owner
    name
    slug
    image
    createdAt
    isMainCategory
    subCategories {
      items {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      nextToken
    }
    mainCategory {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
    productCategoryMainCategoryId
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const listProductCategorys = `query ListProductCategorys(
  $filter: ModelProductCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getSupplier = `query GetSupplier($id: ID!) {
  getSupplier(id: $id) {
    id
    name
    description
    address
    phone
    contact
    url
    api
    schema
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    owner
  }
}
`;
export const listSuppliers = `query ListSuppliers(
  $filter: ModelSupplierFilterInput
  $limit: Int
  $nextToken: String
) {
  listSuppliers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      address
      phone
      contact
      url
      api
      schema
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      owner
    }
    nextToken
  }
}
`;
export const getOrder = `query GetOrder($id: ID!) {
  getOrder(id: $id) {
    id
    owner
    customer {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    orderCustomerId
    total
    order
    createdAt
  }
}
`;
export const listOrders = `query ListOrders(
  $filter: ModelOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      customer {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      orderCustomerId
      total
      order
      createdAt
    }
    nextToken
  }
}
`;
export const getVideoCast = `query GetVideoCast($id: ID!) {
  getVideoCast(id: $id) {
    id
    owner
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
  }
}
`;
export const listVideoCasts = `query ListVideoCasts(
  $filter: ModelVideoCastFilterInput
  $limit: Int
  $nextToken: String
) {
  listVideoCasts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      video {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
    }
    nextToken
  }
}
`;
export const getDesigner = `query GetDesigner($id: ID!) {
  getDesigner(id: $id) {
    id
    owner
    email
    phone
    name
    photo_url
    bio
    location
    active
    createdAt
    posts {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    videos {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
    pro
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    draft_profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    projects {
      items {
        id
        title
        description
        images
        videos
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        projectDesignerId
        owner
      }
      nextToken
    }
  }
}
`;
export const listDesigners = `query ListDesigners(
  $filter: ModelDesignerFilterInput
  $limit: Int
  $nextToken: String
) {
  listDesigners(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getProject = `query GetProject($id: ID!) {
  getProject(id: $id) {
    id
    title
    description
    images
    videos
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    projectDesignerId
    owner
  }
}
`;
export const listProjects = `query ListProjects(
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      images
      videos
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      projectDesignerId
      owner
    }
    nextToken
  }
}
`;
export const getPost = `query GetPost($id: ID!) {
  getPost(id: $id) {
    id
    owner
    title
    description
    content
    status
    thumbnail
    editors {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    createdAt
    likes
    liked
  }
}
`;
export const listPosts = `query ListPosts(
  $filter: ModelPostFilterInput
  $limit: Int
  $nextToken: String
) {
  listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    nextToken
  }
}
`;
export const getComment = `query GetComment($id: ID!) {
  getComment(id: $id) {
    id
    owner
    content
    avatar
    name
    post {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    commentPostId
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    commentVideoId
    createdAt
    likes
    subs
  }
}
`;
export const listComments = `query ListComments(
  $filter: ModelCommentFilterInput
  $limit: Int
  $nextToken: String
) {
  listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      content
      avatar
      name
      post {
        id
        owner
        title
        description
        content
        status
        thumbnail
        editors {
          items {
            id
          }
          nextToken
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        createdAt
        likes
        liked
      }
      commentPostId
      video {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      commentVideoId
      createdAt
      likes
      subs
    }
    nextToken
  }
}
`;
export const getLike = `query GetLike($id: ID!) {
  getLike(id: $id) {
    id
    subject
    objectId
    createdBy
    createdAt
    liked
    owner
  }
}
`;
export const listLikes = `query ListLikes(
  $filter: ModelLikeFilterInput
  $limit: Int
  $nextToken: String
) {
  listLikes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject
      objectId
      createdBy
      createdAt
      liked
      owner
    }
    nextToken
  }
}
`;
export const likesByUser = `query LikesByUser(
  $createdBy: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLikeFilterInput
  $limit: Int
  $nextToken: String
) {
  likesByUser(
    createdBy: $createdBy
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject
      objectId
      createdBy
      createdAt
      liked
      owner
    }
    nextToken
  }
}
`;
export const likesByObject = `query LikesByObject(
  $objectId: ID
  $createdBy: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLikeFilterInput
  $limit: Int
  $nextToken: String
) {
  likesByObject(
    objectId: $objectId
    createdBy: $createdBy
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject
      objectId
      createdBy
      createdAt
      liked
      owner
    }
    nextToken
  }
}
`;
